import { Plus } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { useToast } from '@/hooks/ui/use-toast'
import { authClient } from '@/lib/auth-client'

/**
 * Initiates the Better Auth `linkSocial` flow so the current user can attach an
 * additional Gmail. Returns the user to `/auth/callback/google?flow=link` where
 * `auth-callback.tsx` routes onward; the server hook provisions the account.
 */
export function AddGmailButton() {
  const [isLinking, setIsLinking] = useState(false)
  const { toast } = useToast()

  const handleClick = async () => {
    setIsLinking(true)

    const callbackURL = `${window.location.origin}/auth/callback/google?flow=link`
    const { error } = await authClient.linkSocial({
      provider: 'google',
      callbackURL,
      errorCallbackURL: callbackURL,
      scopes: ['https://www.googleapis.com/auth/gmail.modify', 'openid', 'email'],
    })

    // On success Better Auth navigates the tab to Google; only a failure to
    // start the round-trip comes back here.
    if (error) {
      toast({
        title: 'Could not start Google authorization',
        description: error.message ?? 'Google authorization failed',
        variant: 'destructive',
      })
      setIsLinking(false)
    }
  }

  return (
    <Button disabled={isLinking} onClick={handleClick} size="sm" variant="secondary">
      <Plus className="mr-1 size-4" />
      {isLinking ? 'Connecting…' : 'Add Gmail'}
    </Button>
  )
}
